"use client";
import React from "react";
import { usePathname, useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import { i18nConfig } from "@/lib/i18n";
import Image from "next/image";

export default function LocaleSwitch() {
  const { i18n } = useTranslation();
  const activeLocale = i18n.language;
  const router = useRouter();
  const currentPathname = usePathname();

  const onLanguageChange = () => {
    const newLocale = activeLocale === "it" ? "en" : "it";
    const days = 30;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = date.toUTCString();
    document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;

    const newPath =
      activeLocale === i18nConfig.defaultLocale && !i18nConfig.prefixDefault
        ? "/" + newLocale + currentPathname
        : currentPathname.replace(`/${activeLocale}`, `/${newLocale}`);

    router.push(newPath);
    router.refresh();
  };

  return (
    <button
      onClick={onLanguageChange}
      className="inline-flex items-center gap-2 p-2 text-sm font-medium text-white-700 transition-opacity duration-200 hover:opacity-70 focus:outline-none"
      aria-label="Switch language"
      title={`Switch to ${activeLocale === "it" ? "English" : "Italiano"}`}
    >
      <Image
        src={activeLocale === "it" ? "/UK.svg" : "/italy.svg"}
        alt={activeLocale === "it" ? "UK flag" : "Italy flag"}
        width={24}
        height={24}
      />
      <span>{activeLocale === "it" ? "English" : "Italiano"}</span>
    </button>
  );
}
